import React from 'react';
import dayjs from 'dayjs';
import { DATE_FORMAT_FOR_FILTER } from 'configs/constants';
import CustomDatePicker from 'app/atoms/CustomDatePicker';

/**
 * Renders a date filter dropdown component for table columns
 * @param columnKey - The key to use for the date parameter in the URL
 * @param searchParams - The current URL search parameters
 * @param setSearchParams - Function to update the URL search parameters
 * @param t - Translation function
 * @returns A DateFilterDropdown component
 */
export const renderDateFilterDropdown = (columnKey: string, searchParams: any, setSearchParams: any, t: any) => {
  const DateFilterDropdown = ({ setSelectedKeys, confirm }: any) => {
    // Get the current date value from URL params
    const currentDateValue = searchParams.get(columnKey);

    // Parse the date value if it exists
    const parsedDate = currentDateValue ? dayjs(currentDateValue) : undefined;

    return (
      <div style={{ padding: 8 }}>
        <CustomDatePicker
          allowClear
          onChange={(date) => {
            if (date) {
              // Format the date for URL parameters
              const formattedDate = date.format(DATE_FORMAT_FOR_FILTER);

              // Update URL parameters
              const updatedParams = new URLSearchParams(searchParams);
              updatedParams.set(columnKey, formattedDate);
              setSearchParams(updatedParams);

              // Update selected keys
              setSelectedKeys([formattedDate]);
            } else {
              // Clear the date from URL parameters
              setSearchParams((prev: { delete: (arg0: string) => void }) => {
                prev.delete(columnKey);
                return prev;
              });

              // Clear selected keys
              setSelectedKeys([]);
            }

            confirm();
          }}
          value={parsedDate}
          placeholder={t('dashboard.selectDate')}
        />
      </div>
    );
  };

  DateFilterDropdown.displayName = `DateFilterDropdown(${columnKey})`;

  return DateFilterDropdown;
};
